import { useState } from 'react'

import Check from '../../../assets/images/icons/check.svg?react'
import CheckMark from '../../../assets/images/icons/mark.svg?react'
import '../../../assets/styles/checkbox.css'

type ManageTableCheckboxProps = {
  handleCheckboxChange: any
  isChecked: boolean
  customTop?: string
  disabled?: boolean
}

function ManageTableCheckbox({
  handleCheckboxChange,
  isChecked,
  customTop,
  disabled = false,
}: ManageTableCheckboxProps) {
  return (
    <>
      <button
        disabled={disabled}
        type="button"
        // onClick={(e) => {
        //   if (!disabled) handleCheckboxChange(e)
        // }}
        className="checkbox-wrapper relative cursor-pointer h-5 w-5 mr-2 z-[50]"
      >
        <input
          checked={isChecked}
          disabled={disabled}
          onChange={(e) => {
            if (!disabled) handleCheckboxChange(e)
          }}
          id="default-checkbox"
          type="checkbox"
          value="true"
          className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 cursor-pointer disabled:bg-gray-400"
        />

        <CheckMark
          className={`checkmark absolute left-[4.7px] ${
            customTop ? customTop : ' top-[6.5px] '
          } ${disabled ? 'opacity-50' : ''}`}
        />
      </button>
    </>
  )
}

export default ManageTableCheckbox
